import React from 'react';
import './post-slim.scss';
import { setLandToElement } from '../../utils/land-to-element';
import { generateIntCmpFromTenant, setDataLayerElement } from '../../utils/tracking-data';
import { getDateTime } from '../../utils/times';
import { ComponentProps } from '../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../utils/styles';
import PostTimestamp from '../post-timestamp/post-timestamp';
import { LiveblogTenant } from '../../typings/liveblog-themes';

export interface IPostSlim extends ComponentProps {
  tenant: LiveblogTenant;
  href?: string;
  postId: string;
  title: string;
  dateNow: Date;
  timestamp: string; // ISO format like '2022-10-18T09:01:22.423Z'
  timestampUtcIt?: string; // ISO format like '2022-10-18T11:01:22.423+02:00'
}

const classNames = (): IClassNames =>
  makeClassNames({
    PostSlim: 'post-slim',
    PostSlimTitle: 'post-slim__title',
  });

const handleClickOnPostSlim = (postId: string, intcmp: string) => {
  setLandToElement(postId);
  setDataLayerElement(intcmp);
};

const PostSlim: React.FC<IPostSlim> = ({ tenant, href, postId, title, dateNow, timestamp, timestampUtcIt }) => {
  const cn = classNames();

  const { time } = getDateTime({ timestamp, dateNow });
  const intcmp = generateIntCmpFromTenant(tenant, 'homepage_liveblog-card_detail-link');

  return (
    <a
      className={cn.PostSlim}
      href={href}
      data-intcmp={intcmp}
      onClick={() => handleClickOnPostSlim(postId, intcmp)}
    >
      <PostTimestamp timestampUtcIt={timestampUtcIt} timestamp={timestamp} time={time} />
      <h2 className={cn.PostSlimTitle} dangerouslySetInnerHTML={{ __html: title }} />
    </a>
  );
};

export default PostSlim;
